module.exports = __webpack_public_path__ + "static/media/loader.46695451.gif";